import React from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'
import { InputText, InputTextProps } from 'primereact/inputtext'
import { TooltipOptions } from 'primereact/tooltip/tooltipoptions'
import { classNames } from 'primereact/utils'

export interface InputTextToggleableProps extends InputTextProps {
  checked: boolean
  onCheckedChange: (event: CheckboxChangeEvent) => void
  checkboxTooltip?: string
  checkboxTooltipOptions?: TooltipOptions
}

export const InputTextToggleable: React.FC<InputTextToggleableProps> = ({
  checked = false,
  onCheckedChange,
  checkboxTooltip,
  checkboxTooltipOptions,
  disabled,
  ...props
}) => {
  const { t } = useTranslation()

  if (disabled)
    return <InputText className="w-full" disabled={disabled} {...props} />

  return (
    <div className="p-inputgroup">
      <span
        className={classNames('p-inputgroup-addon', { 'p-disabled': !checked })}
      >
        <Checkbox
          checked={checked}
          onChange={onCheckedChange}
          tooltip={
            checkboxTooltip ||
            t('components.inputs.inputTextToggleable.checkBoxTooltip')
          }
          tooltipOptions={{
            ...checkboxTooltipOptions,
            position: checkboxTooltipOptions?.position || 'left',
          }}
        />
      </span>
      <InputText disabled={disabled || !checked} {...props} />
    </div>
  )
}
